import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import MoneyFormat from '../../layout/MoneyFormat';
import TableSpinner from '../../layout/TableSpinner';
import CustomPaginationWithManyPages from '../../layout/CustomPaginationWithManyPages';

const SparePartSales = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    
    // Extract ID from URL path manually
    const id = location.pathname.match(/\/spare-parts\/(\d+)/)?.[1];
    
    // For now, we'll use a placeholder state until the actual action is implemented
    const [loading, setLoading] = useState(false);
    const [salesData, setSalesData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [numberOfPages, setNumberOfPages] = useState(1);
    
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    useEffect(() => {
        if (id) {
            // TODO: Implement getSparepartSales action when backend is ready
            // dispatch(getSparepartSales(id, { from_date: fromDate, to_date: toDate }));
        }
    }, [dispatch, id, fromDate, toDate]);

    const onChangeFromDate = (event) => {
        setFromDate(event.target.value);
        // TODO: Implement filtering when action is ready
    };

    const onChangeToDate = (event) => {
        setToDate(event.target.value);
        // TODO: Implement filtering when action is ready
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        // TODO: Implement pagination when action is ready
    };

    if (loading) {
        return <TableSpinner />;
    }

    return (
        <div>
            <div className="card">
                <div className="card-header">
                    <h5 className="card-title mb-0">Ehtiyot qismi sotuvlari</h5>
                </div>
                <div className="card-body">
                    {/* Date filters */}
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label htmlFor="from_date" className="form-label">Dan</label>
                            <input 
                                id="from_date"
                                type="date" 
                                className="form-control"
                                value={fromDate}
                                onChange={onChangeFromDate}
                            />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="to_date" className="form-label">Gacha</label>
                            <input 
                                id="to_date"
                                type="date" 
                                className="form-control"
                                value={toDate}
                                onChange={onChangeToDate}
                            />
                        </div>
                    </div>

                    {salesData && salesData.length > 0 ? (
                        <>
                            <div className="table-responsive">
                                <table className="table table-striped table-hover">
                                    <thead className="table-dark">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Sotuv ID</th>
                                            <th scope="col">Sotuvchi</th>
                                            <th scope="col">Mijoz</th>
                                            <th scope="col">Miqdori</th>
                                            <th scope="col">Narxi</th>
                                            <th scope="col">Summa</th>
                                            <th scope="col">Sana</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {salesData.map((sale, index) => (
                                            <tr key={sale.id}>
                                                <td>{(currentPage - 1) * 10 + index + 1}</td>
                                                <td>
                                                    <Link to={`/sales/${sale.id}`} className="text-primary fw-bold">
                                                        #{sale.id}
                                                    </Link>
                                                </td>
                                                <td>
                                                    <Link to={`/users/${sale.seller?.id}`}>
                                                        {sale.seller?.name || '---'}
                                                    </Link>
                                                </td>
                                                <td>
                                                    <Link to={`/clients/${sale.client?.id}`}>
                                                        {sale.client?.name || '---'}
                                                    </Link>
                                                </td>
                                                <td>
                                                    <MoneyFormat value={sale.quantity} thousandSeparator={true} />
                                                </td>
                                                <td>
                                                    <MoneyFormat value={sale.price} thousandSeparator={true} /> so'm
                                                </td>
                                                <td>
                                                    <MoneyFormat value={sale.total_amount} thousandSeparator={true} /> so'm
                                                </td>
                                                <td>{sale.date}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            
                            {numberOfPages > 1 && (
                                <div className="d-flex justify-content-center mt-3">
                                    <CustomPaginationWithManyPages
                                        numberOfPages={numberOfPages}
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="text-center py-4">
                            <p className="text-muted">Bu ehtiyot qismi uchun hech qanday sotuv topilmadi.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SparePartSales; 